import { render, staticRenderFns } from "./GameMedals.vue?vue&type=template&id=3f41bcc6&"
import script from "./GameMedals.vue?vue&type=script&lang=js&"
export * from "./GameMedals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports